import Clarifai from 'clarifai';

const clarifaiApp = new Clarifai.App({
  apiKey: process.env.NEXT_PUBLIC_CLARIFAI_API_KEY,
  userAppId: {
    user_id: process.env.NEXT_PUBLIC_CLARIFAI_USER_ID,
    app_id: process.env.NEXT_PUBLIC_CLARIFAI_APP_ID
  }
});

export default clarifaiApp;